import { render } from "./FpuiInputSelectCategories.vue?vue&type=template&id=4ef16be2&lang=pug"
import script from "./FpuiInputSelectCategories.vue?vue&type=script&lang=js"
export * from "./FpuiInputSelectCategories.vue?vue&type=script&lang=js"

import "./FpuiInputSelectCategories.vue?vue&type=style&index=0&id=4ef16be2&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__